import { useNavigate } from 'react-router-dom';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useGetProfile } from '@/lib/hooks/api/profile.hook';
import { useTokenStore, useUserStore } from '@/store';
import { Logout } from '../shared/Logout';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export function ProfileDropdown() {
  const { user } = useUserStore();
  const navigate = useNavigate();
  const { token } = useTokenStore();
  const { data } = useGetProfile({
    enabled: !!token,
  });

  const profile = data?.data?.data ?? user;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <div
          role="button"
          className="flex items-center h-full rounded-none gap-3 hover:bg-secondary transition hover:text-secondary-foreground px-1 md:px-2 -mr-1 md:-mr-2"
          data-testid="profile-dropdown-trigger"
        >
          {/* {profile?.name && (
            <h5 className="capitalize hidden md:block">
              {profile?.name as string}
            </h5>
          )} */}

          <Avatar>
            <AvatarImage
              src={profile?.imageURL as string}
              alt="profile"
              className="w-full h-full object-cover"
            />
            <AvatarFallback className="text-2xl uppercase">
              {profile?.name?.[0] as string}
            </AvatarFallback>
          </Avatar>
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="min-w-[200px]" align="end">
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={() => {
            navigate('/profile');
          }}
        >
          Profile
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="w-full cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
          }}
          data-testid="logout-profile-dropdown"
        >
          <Logout>
            <span className="w-full">Log out</span>
          </Logout>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
